import {
  AnswersActionTypes,
  AnswersState,
  FETCH_ANSWERS_FULFILLED,
  FETCH_ANSWERS_PENDING,
  FETCH_ANSWERS_REJECTED,
  SAVE_ANSWER_FULFILLED,
  SAVE_ANSWER_PENDING,
  SAVE_ANSWER_REJECTED,
} from './types';

const initialState = {
  fetching: false,
  fetched: false,
  items: [],
  error: null,
  nbResult: 0,
  saving: false,
  saved: false,
};

export const reducer = (
  state: AnswersState = initialState,
  action: AnswersActionTypes,
) => {
  switch (action.type) {
    case FETCH_ANSWERS_PENDING: {
      return {
        ...state,
        fetched: false,
        fetching: true,
      };
    }
    case FETCH_ANSWERS_FULFILLED: {
      const { data, nbResult } = action.payload;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: [...data[0]],
        nbResult: nbResult,
      };
    }
    case FETCH_ANSWERS_REJECTED: {
      let error = action.payload;
      switch (error?.response?.status) {
        case 404:
          error = {
            title: error?.response?.data?.title,
            code: 404,
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        fetched: false,
        error: error,
        items: [],
        nbResult: 0,
      };
    }
    case SAVE_ANSWER_PENDING: {
      return {
        ...state,
        saved: false,
        saving: true,
      };
    }
    case SAVE_ANSWER_FULFILLED: {
      const { data } = action.payload;
      return {
        ...state,
        saving: false,
        saved: true,
        error: null,
      };
    }
    case SAVE_ANSWER_REJECTED: {
      let error = action.payload;
      switch (error?.response?.status) {
        case 404:
          error = {
            title: error?.response?.data?.title,
            code: 404,
          };
          break;
        default:
      }
      return {
        ...state,
        saving: false,
        saved: false,
        error: error,
      };
    }
    default:
      return state;
  }
};
export default reducer;
